import {
  closeIndicator,
  type FabricToastCloseIndicatorApi,
} from './show-indicator.js';
import { type FabricToastShowMessageApi, showMessage } from './show-message.js';
import {
  closeSpinner,
  type FabricToastCloseSpinnerApi,
  type FabricToastShowSpinnerApi,
  showSpinner,
} from './show-spinner.js';

export type FabricToastApi = {
  /**
   * 显示Native全屏动画
   */
  showSpinner: FabricToastShowSpinnerApi;
  /**
   * 关闭Native全屏幕动画
   */
  closeSpinner: FabricToastCloseSpinnerApi;
  /**
   * 关闭Native全屏幕动画
   */
  closeIndicator: FabricToastCloseIndicatorApi;
  /**
   * 弹出toast tip message
   */
  showMessage: FabricToastShowMessageApi;
};

export const fabricToast: FabricToastApi = {
  showSpinner,
  closeSpinner,
  showMessage,
  closeIndicator,
};
